module.exports = __webpack_public_path__ + "static/media/tax_reports.824ecb24.png";